import { ChangeEvent } from 'react';
import { Text } from '@nimbus-ds/components';
import { FormField } from '@nimbus-ds/patterns';
import { PromotionTypes } from '@tiendanube/common/src/domains/marketing/promotions/PromotionTypes';
import { useTranslationMarketing } from 'domains/Marketing/hook';
import { ErrorBox } from './ErrorBox';
import { PromotionFormProps } from '../PromotionForm';

export function PercentageOff({
  values,
  errors,
  onChangePercentageOff,
}: Readonly<
  Pick<PromotionFormProps, 'values' | 'errors' | 'onChangePercentageOff'>
>) {
  const t = useTranslationMarketing('promotions.settingsPage.discountType');

  const { promotionType, percentageOffDiscount } = values;

  const { percentageOffDiscount: error } = errors || {};

  if (promotionType !== PromotionTypes.PERCENTAGE_OFF) return null;

  const handlePercentageOffChange = (event: ChangeEvent<HTMLInputElement>) => {
    const sanitizedValue = event.target.value.replace(/\D/g, '');

    onChangePercentageOff(parseInt(sanitizedValue || '0', 10));
  };

  return (
    <>
      <FormField.Input
        name="discount"
        label={t('percentageOff.discountPercentage')}
        value={percentageOffDiscount || ''}
        onChange={handlePercentageOffChange}
        append={<Text color="neutral-textLow">%</Text>}
        appendPosition="end"
        appearance={error ? 'danger' : undefined}
      />
      {!!error && <ErrorBox errorMessage={t(error)} />}
    </>
  );
}
